/*
 * autocompleteForMask allows autocomplete usability on masked fields, also removing the maxlength for proper autofilling
 *
 * Maxlength support was removed for jQuery Mask Plugin: https://github.com/igorescobar/jQuery-Mask-Plugin/commit/8b9cd71f7b72ffb4a38a49379418b7ab8893aa29
 * Why autocomplete was off: https://github.com/igorescobar/jQuery-Mask-Plugin/blob/master/src/jquery.mask.js#L440
 * Where maxlength was set: https://github.com/igorescobar/jQuery-Mask-Plugin/blob/master/src/jquery.mask.js#L457
 *
 * Facilitates:
 * - jQuery Mask Plugin
 */

const autocompleteForMask = () => {
  const $triggers = document.querySelectorAll('[autocomplete="off"]');
  for (let i = 0; i < $triggers.length; i += 1) {
    const $el = $triggers[i];
    $el.setAttribute('autocomplete', $el.getAttribute('data-autocomplete'));
    $el.removeAttribute('maxlength');
  }
};
export default autocompleteForMask;
